var _path, _rect, _rect2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.66 26.5002C14.66 33.0392 19.961 38.3402 26.5 38.3402C33.0391 38.3402 38.34 33.0392 38.34 26.5002C38.34 19.9611 33.0391 14.6602 26.5 14.6602C19.961 14.6602 14.66 19.9611 14.66 26.5002ZM26.5 11.6602C18.3041 11.6602 11.66 18.3043 11.66 26.5002C11.66 34.6961 18.3041 41.3402 26.5 41.3402C34.6959 41.3402 41.34 34.6961 41.34 26.5002C41.34 18.3043 34.6959 11.6602 26.5 11.6602Z",
    fill: "#DAE1E6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.4399,
    y: 17,
    width: 2.12,
    height: 10.6,
    rx: 1,
    fill: "#DAE1E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9699,
    y: 29.5547,
    width: 2,
    height: 6.44282,
    rx: 1,
    transform: "rotate(135 30.9699 29.5547)",
    fill: "#DAE1E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 49C38.9264 49 49 38.9264 49 26.5C49 14.0736 38.9264 4 26.5 4C14.0736 4 4 14.0736 4 26.5C4 38.9264 14.0736 49 26.5 49ZM26.5 53C41.1355 53 53 41.1355 53 26.5C53 11.8645 41.1355 0 26.5 0C11.8645 0 0 11.8645 0 26.5C0 41.1355 11.8645 53 26.5 53Z",
    fill: "#DAE1E6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.7cd338f3d08f0b9eb5febf6244711a3d.svg";
export { ForwardRef as ReactComponent };